import { CallbackWrap } from '@/types/common'
import { Embed } from '@/types/embed'
import { LevelingEmbed } from '@/types/leveling'
import { faEdit } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  RichTextEditor,
  SerializedEditorState
} from 'components/editor/rich-text-editor/RichTextEditor'
import React from 'react'
import './tips-and-tricks.scss'

export function TipsAndTricks({
  embed,
  onEmbedChange,
  isActiveTab
}: {
  embed: LevelingEmbed
  onEmbedChange?: (value: CallbackWrap<Embed>) => void
  isActiveTab?: boolean
}) {
  const [isEditing, setIsEditing] = React.useState(false)

  const onAttrChange = React.useCallback(
    (newValue: SerializedEditorState | undefined) =>
      onEmbedChange?.((embed) => {
        if (embed.type !== 'leveling') return embed
        embed = { ...embed }
        if (newValue) {
          embed.tipsAndTricks = newValue
        } else {
          delete embed.tipsAndTricks
        }
        return embed
      }),
    [onEmbedChange]
  )

  return (
    <div className="poe-tips-and-tricks">
      <div className="poe-title-box">
        {!!onEmbedChange && (
          <span>
            {isEditing ? (
              <button onClick={() => setIsEditing(false)}>Close</button>
            ) : (
              <FontAwesomeIcon
                icon={faEdit}
                onClick={() => {
                  setIsEditing(!isEditing)
                }}
              />
            )}
          </span>
        )}
        Tips & Tricks
      </div>

      <RichTextEditor
        render={true}
        key={`${embed.id}-tipsAndTricks-content`}
        value={embed?.tipsAndTricks}
        isEditing={isEditing}
        onChange={
          onEmbedChange
            ? (newValue) => {
                onAttrChange(newValue)
              }
            : undefined
        }
      />
    </div>
  )
}
